import Image from 'components/AppImage';
import Icon from 'components/AppIcon';

const HeroSection = () => {
  const features = [
    {
      icon: 'TrendingUp',
      title: 'Revenue Forecasting',
      description: 'Predict occupancy, ADR, and revenue with advanced analytics',
    },
    {
      icon: 'BarChart3',
      title: 'Real-time KPIs',
      description: 'Monitor RevPAR, pickup, and pace comparisons instantly',
    },
    {
      icon: 'Target',
      title: 'Optimization Tools',
      description: 'Maximize revenue with data-driven pricing strategies',
    },
  ];

  return (
    <div className="hidden lg:flex lg:flex-1 lg:flex-col lg:justify-center lg:px-8">
      <div className="mx-auto max-w-md text-center">
        {/* Hero Image */}
        <div className="mb-8 relative">
          <div className="aspect-video rounded-lg overflow-hidden shadow-large">
            <Image
              src="https://images.unsplash.com/photo-1551836022-deb4988cc6c0?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
              alt="Hotel revenue management dashboard showing analytics and forecasting charts"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent rounded-lg"></div>
        </div>

        {/* Hero Content */}
        <div className="space-y-6">
          <div>
            <h2 className="text-3xl font-bold text-text-primary mb-4">Maximize Your Hotel Revenue</h2>
            <p className="text-lg text-text-secondary leading-relaxed">
              Leverage advanced forecasting and analytics to optimize pricing strategies and drive revenue growth across
              your properties.
            </p>
          </div>

          {/* Feature Highlights */}
          <div className="space-y-4">
            {features.map((feature, index) => (
              <div key={index} className="flex items-start space-x-4 text-left">
                <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Icon name={feature.icon} size={20} className="text-primary" />
                </div>
                <div>
                  <h3 className="font-medium text-text-primary mb-1">{feature.title}</h3>
                  <p className="text-sm text-text-secondary">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Trust Indicators */}
          <div className="pt-6 border-t border-border">
            <div className="flex items-center justify-center space-x-6 text-text-secondary">
              <div className="flex items-center space-x-2">
                <Icon name="Shield" size={16} />
                <span className="text-sm">Enterprise Security</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Clock" size={16} />
                <span className="text-sm">24/7 Support</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
